module.exports = __webpack_public_path__ + "static/media/Loading_Bar_Inset@3x.c39e617a.png";